import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "@/api/client";
import { Bell, Check, CheckCheck } from "lucide-react";

export default function NotificationsPage() {
  const [items, setItems] = useState([]); const nav = useNavigate();
  const load = () => apiClient.get("/notifications").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const markAll = async () => { await apiClient.post("/notifications/read-all"); load(); };
  const onClick = async (n) => { await apiClient.post(`/notifications/${n.id}/read`); if (n.link) nav(n.link); else load(); };

  return (
    <div className="space-y-5" data-testid="notifications-page">
      <div className="flex items-center justify-between"><h1 className="text-2xl font-bold">Bildirimler</h1><button onClick={markAll} className="ky-btn ky-btn-outline ky-btn-sm"><CheckCheck size={12}/>Tümünü oku</button></div>
      <div className="ky-card overflow-hidden">
        {items.length === 0 && <div className="text-center py-16 text-[#94A3B8] flex flex-col items-center gap-2"><Bell size={32}/>Bildirim yok.</div>}
        {items.map(n => (
          <button key={n.id} onClick={() => onClick(n)} className={`w-full flex items-start gap-3 px-5 py-3.5 border-b border-[#ECECEF] hover:bg-[#FAFAFB] text-left ${!n.is_read ? "bg-[#EEF2FF]/30" : ""}`}>
            {!n.is_read ? <span className="ky-dot bg-[#4F46E5] mt-2"/> : <Check size={12} className="text-[#94A3B8] mt-1"/>}
            <div className="flex-1 min-w-0">
              <div className="text-sm">{n.title}</div>
              <div className="text-[11px] text-[#94A3B8] mt-0.5">{new Date(n.created_at).toLocaleString("tr-TR")} · {n.type}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
